import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

const BASE = `${BASE_URL}/api/v1`;

export const getConsentTemplates = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/consent-templates`, { params }).then((r) => r.data);

export const getConsentTemplate = (id: number) =>
  api.get(`${BASE}/consent-templates/${id}`).then((r) => r.data);

export const getConsentTemplateSourcePdfUrl = (id: number) =>
  `${BASE}/consent-templates/${id}/source-pdf`;

export const getConsentTemplateSourcePdfBlob = async (id: number): Promise<Blob> => {
  const res = await api.get(`${BASE}/consent-templates/${id}/source-pdf`, { responseType: "blob" });
  return res.data;
};

export const updateConsentTemplateField = (
  templateId: number,
  fieldId: number,
  payload: { x?: number; y?: number; x_max?: number | null; page?: number }
) => api.patch(`${BASE}/consent-templates/${templateId}/fields/${fieldId}`, payload).then((r) => r.data);

// Patient Consents
export const getPatientConsents = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/patient-consents`, { params }).then((r) => r.data);

export const getPatientConsent = (id: number) =>
  api.get(`${BASE}/patient-consents/${id}`).then((r) => r.data);

export const createPatientConsent = (payload: Record<string, any>) =>
  api.post(`${BASE}/patient-consents`, camelToSnake(payload)).then((r) => r.data);

export const updatePatientConsent = (
  id: number,
  payload: { filledData: Record<string, string>; notes?: string | null }
) => api.patch(`${BASE}/patient-consents/${id}`, camelToSnake(payload)).then((r) => r.data);

export const updatePatientConsentStatus = (id: number, status: string) =>
  api.patch(`${BASE}/patient-consents/${id}/status`, { status }).then((r) => r.data);

export const getPatientConsentPdfUrl = (id: number) =>
  `${BASE}/patient-consents/${id}/pdf`;

export const openPatientConsentPdf = async (id: number): Promise<void> => {
  const res = await api.get(`${BASE}/patient-consents/${id}/pdf`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
};
